import { APIService } from "../apiService";
import { AuthenticationService } from "../authenticationService";
import { PaginatedTransitPurchaseOrders, S3SignedUrl, TransitPurchaseOrder } from "src/types";
import {
  GetTransitPurchaseOrdersQueryParams,
  GetTransitPurchaseOrderByIdQueryParams,
  PatchTransitPurchaseOrderRequestBody,
  PostTransitPurchaseOrdersExportsRequestBody
} from "src/types/api";

class TransitPurchaseOrderAPIService extends APIService {
  constructor(authenticationService: AuthenticationService) {
    super(authenticationService, "/v1/purchase-orders");
  }

  async getTransitPurchaseOrders(
    queryParams: GetTransitPurchaseOrdersQueryParams
  ): Promise<PaginatedTransitPurchaseOrders> {
    return await this.jwtRequest("GET", "/transit", undefined, queryParams);
  }

  async getTransitPurchaseOrderById(
    transitPurchaseOrderId: string,
    queryParams?: GetTransitPurchaseOrderByIdQueryParams
  ): Promise<TransitPurchaseOrder> {
    const pathParam = encodeURIComponent(transitPurchaseOrderId);
    const path = `/transit/${pathParam}`;

    return await this.jwtRequest("GET", path, undefined, queryParams);
  }

  async patchTransitPurchaseOrder(
    transitPurchaseOrderId: string,
    requestBody: PatchTransitPurchaseOrderRequestBody
  ): Promise<TransitPurchaseOrder> {
    const pathParam = encodeURIComponent(transitPurchaseOrderId);
    const path = `/transit/${pathParam}`;

    return await this.jwtRequest("PATCH", path, requestBody);
  }

  async postTransitPurchaseOrdersExports(
    requestBody: PostTransitPurchaseOrdersExportsRequestBody
  ): Promise<S3SignedUrl> {
    return await this.jwtRequest("POST", "/transit/exports", requestBody);
  }
}

export { TransitPurchaseOrderAPIService };
